/**
 * PWA Service Worker Registration:
 * In development mode, we actively unregister any stale service workers
 * to ensure developers always receive instant HMR updates with zero caching.
 * In production, we allow the service worker to register normally to enable
 * offline writing support and clean in-app update prompts.
 */
import { isAndroidPlatform } from "./platform";

export async function registerServiceWorker(): Promise<void> {
  if (import.meta.env.DEV || isAndroidPlatform()) {
    if ("serviceWorker" in navigator) {
      navigator.serviceWorker.getRegistrations().then((registrations) => {
        for (const registration of registrations) {
          registration.unregister();
          console.log("Automatically unregistered active dev/android service worker.");
        }
      });
    }
  }
}

